import axios, { AxiosResponse } from 'axios';
import { concat } from 'lodash';

const API_KEY = 'AIzaSyBLGnE70lNm2rKMwYg8RPBGQC4BZyuqxsw';

interface GeoLocation {
    lat: number;
    lng: number;
}

interface Viewport {
    northeast: GeoLocation;
    southwest: GeoLocation;
}

class GeocodeService {
    readonly url = 'https://maps.googleapis.com/maps/api/geocode/json';

    getGeocoding(address1: string, address2: string, city: string, state: string|null, zip: string|null): Promise<GeoLocation> {
        const address = encodeURI(concat(address1, address2, city, state, zip).join('+'));
        const callApi = axios.create({});
        return callApi.get(this.url + `?address=${address}&key=${API_KEY}`)
            .then((resp: AxiosResponse) => {
                return resp.data.results[0].geometry.location;
            })
            .catch(() => {
                return Promise.reject;
            });
    }
}

export default GeocodeService;
export {
    GeoLocation,
}